import { set } from "dot-prop-immutable";

import { unitsChangedAction } from "../einheiten/Units";

const SETTINGS_CHANGED = "SETTINGS_CHANGED";

export const settingsChangedAction = (which, value) => ({
	type: SETTINGS_CHANGED, which, value
});

/* Kein Teil des Reducers, deswegen können hier Seiteneffekte
 * eingebaut werden.
 */
export const acceptNewSettings = (settings, dispatch) => {
	if (settings.which === "units") {
		dispatch(unitsChangedAction(settings.value));
	}
	dispatch(settingsChangedAction(settings.which, settings.value));
};

const initial_state = {
	network: {},
	user: {},
	units: {},
	email: {},
	print: {},
	share: {},
	rights: {},
	time: {}
};

export const settingsReducer = (state = initial_state, action) => {
	switch (action.type) {
	case SETTINGS_CHANGED:
		return set(state, action.which, action.value);
	default:
		return state;
	}
};
